<div id="products" class="page-layout carded fullwidth" fusePerfectScrollbar>

  <!-- TOP BACKGROUND -->
  <div class="top-bg mat-accent-bg"></div>
  <!-- / TOP BACKGROUND -->

  <!-- CENTER -->
  <div class="center">

    <!-- HEADER -->
    <div class="header white-fg"
         fxLayout="column" fxLayoutAlign="center center"
         fxLayout.gt-xs="row" fxLayoutAlign.gt-xs="space-between center">

      <!-- APP TITLE -->
      <div class="logo my-12 m-sm-0"
           fxLayout="row" fxLayoutAlign="start center">
        <mat-icon class="logo-icon mr-16" *fuseIfOnDom
                  [@animate]="{value:'*',params:{delay:'50ms',scale:'0.2'}}">dashboard</mat-icon>
        <span class="logo-text h1" *fuseIfOnDom
              [@animate]="{value:'*',params:{delay:'100ms',x:'-25px'}}">{{'main.dynamicForm' | translate}}</span>
      </div>

      <button mat-raised-button
              [routerLink]="'/pages/dynamicForm/new'"
              class="add-product-button mat-white-bg my-12 mt-sm-0">
        <span>{{'add_new_dynamic_form' | translate}}</span>
      </button>
    </div>


    <!-- / HEADER -->
    <!-- CONTENT CARD -->
    <mat-sidenav-container class="my-sidenav" style="  position: absolute;
    width: 210px;
    height: calc(100vh - 210px);
    right: 0;
    z-index: 999;
    top: 136px;
    background: white;">
      <mat-sidenav #sidenav class="sidenav mat-sidenav-opened" position="end" opened="true" mode="side"
                   fuseMatSidenavHelper="sidenav" mat-is-locked-open="gt-sm" [ngClass]="{'hide-menu': !sidenav.opened}" style="    position: absolute;
    width: 100%;
    margin: 0px;
    display: flex;
    flex: 1 1 0%;
    flex-direction: column;
    overflow: hidden;
    transform: none;
    visibility: visible;">
        <div class="form-element">
          <div class="title">{{'form_elements' | translate}}</div>
          <div class="add-element" (click)="addElement('')">
            <mat-icon>short_text</mat-icon>{{'input_field' | translate}}</div>
          <div class="add-element" (click)="addElement('')">{{'textarea_field' | translate}}</div>
          <div class="add-element" (click)="addElement('')">{{'checkbox' | translate}}</div>
          <div class="add-element" (click)="addElement('')">{{'radio_buttons' | translate}}</div>
          <div class="add-element" (click)="addElement('')">{{'date_field' | translate}}</div>
          <div class="add-element" (click)="addElement('')">{{'upload_field' | translate}}</div>
        </div>
      </mat-sidenav>
    </mat-sidenav-container>

    <div class="content-card mat-white-bg" [ngClass]="{'margin-big-screen': sidenav.opened}">
    </div>

    <!-- / CONTENT CARD -->
  </div>
  <!-- / CENTER -->
</div>
